import styled from 'styled-components/macro';
import { Alert } from '@yme/atoms/alert';
import { alertVisibilityEffectStyled } from '@yme/utils/styles';
export const InformationAlertStyled = styled(Alert) `
  ${alertVisibilityEffectStyled}
`;
